import httpHelper from "@/helpers/httpHelper";

const roleService = {
    async getRolesByServer(idServer) {
        return await httpHelper.get("/WebApi/Role/GetRolesByServer", {idServer});
    },
};

export default roleService;